import { InfoCircleOutlined } from "@ant-design/icons";
import { Divider, Tag } from "antd";
import React from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { formatCurrency } from "../../modules/formatCurrency";

export const RatePlans = (props) => {
  const {
    showAddOnServices,
    rates,
    branding,
    currency,
    convertAmount,
    handlePickRatePlan,
    setShowAddOnServices,
  } = props;
  const { t } = useTranslation();
  return (
    <div className="rate-info col-md-12">
      {Object.keys(rates).map((rateplanname, index) => (
        <React.Fragment key={index}>
          <div className="promo-tag-row mb-2">
            {rates[rateplanname].appliedPromotions?.map((promotion, idx) => (
              <Tag
                color={promotion.type === "Promo Code" ? "blue" : "green"}
                className="promo-tag"
                key={idx}
              >
                {promotion.type === "Promo Code"
                  ? `Code:`
                  : `  ${promotion.type}`}{" "}
                {promotion.percentage}% Off
              </Tag>
            ))}
          </div>
          <div
            className="d-flex align-items-center"
            style={{ marginBottom: "8px" }}
          >
            <p
              style={{
                fontSize: "20px",
                marginRight: "10px",
                color: branding.headingColor,
                fontFamily: branding.headingFont,
              }}
            >
              <strong>{rateplanname}:</strong>
            </p>
            <div className="ms-auto d-flex align-items-center">
              <div className="rate-pricing mb-3">
                {rates[rateplanname].appliedPromotions?.length > 0 && (
                  <span
                    className="original-rate"
                    style={{
                      fontSize: "16px",
                      fontFamily: "Bebas Neue",
                      textDecoration: "line-through",
                      marginBottom: "15px",
                      marginRight: "8px",
                      color: branding.priceTagColor,
                    }}
                  >
                    {formatCurrency({
                      amount: rates[rateplanname].originalTotalRate,
                      currency,
                      convertAmount,
                    })}
                  </span>
                )}
                <span
                  className="total-rate"
                  style={{
                    fontSize: "25px",
                    fontFamily: "Bebas Neue",
                    color: branding.priceTagColor,
                    marginRight: "8px",
                    marginTop: "10px",
                  }}
                >
                  <strong>
                    {formatCurrency({
                      amount: rates[rateplanname].totalRate,
                      currency,
                      convertAmount,
                    })}
                  </strong>
                </span>
              </div>
              <Button
                variant="success"
                className="pick-button mb-4"
                onClick={() => {
                  handlePickRatePlan(rateplanname, rates[rateplanname]);
                  if (!showAddOnServices) setShowAddOnServices(true);
                }}
              >
                {t("room.pick")}
              </Button>
            </div>
          </div>
          <p
            className="meal-cancel"
            style={{
              fontSize: "12px",
              fontStyle: "italic",
              color: "#555",
              marginTop: "-30px",
              marginBottom: "8px",
            }}
          >
            <span>
              <InfoCircleOutlined style={{ marginRight: "5px" }} />
              <strong>{t("room.meal_plan")}:</strong>{" "}
              {rates[rateplanname].mealPlan}
            </span>
            <br />
            <span>
              <InfoCircleOutlined style={{ marginRight: "5px" }} />
              <strong>{t("room.cancellation_policy")}: </strong>
              {rates[rateplanname].cancellationPolicy.chargeType ===
              "Non-refundable" ? (
                <>
                  {rates[rateplanname].cancellationPolicy.chargeType} -{" "}
                  {rates[rateplanname].cancellationPolicy.chargePercentage}%
                  charge.
                </>
              ) : (
                <>
                  {rates[rateplanname].cancellationPolicy.chargeType} -{" "}
                  {rates[rateplanname].cancellationPolicy.chargePercentage}%
                  charge if canceled{" "}
                  {rates[rateplanname].cancellationPolicy.daysBeforeCheckin}{" "}
                  days before check-in.
                </>
              )}
            </span>
          </p>
          <Divider style={{ margin: "8px 0" }} />
        </React.Fragment>
      ))}
    </div>
  );
};
